var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'nuxt-property-decorator';
import { API_PATHS } from '~/router';
import AbstractPage from '~/mixins/AbstractPage';
let DefaultPage = class DefaultPage extends AbstractPage {
    constructor() {
        super(...arguments);
        this.back_button_link = '';
        this.back_button_text = '';
        this.elements = [];
        this.intro_text = '';
        this.show_back_button = false;
        this.title = '';
    }
    async asyncData({ route, $axios }) {
        const path = route.fullPath || route.path;
        const response = await $axios.get(`${API_PATHS.PAGES}${path}`);
        return {
            ...response.data,
            pageTitle: response.data.title
        };
    }
};
DefaultPage = __decorate([
    Component
], DefaultPage);
export default DefaultPage;
